import { Button, Card, CardActions, CardContent, TextField } from "@mui/material";
import { Stack } from "@mui/system";
import { ChangeEvent, useCallback,useEffect, useState } from "react";
import { connect as reduxConnect } from "react-redux";
import { useNavigate } from "react-router-dom";
import QueueService from "services/queue.service";
import { ApplicationState } from "store";
import { setConfig, setOutletId } from "store/config/config.action";
import { ConfigState } from "store/config/config.reducer";

const bgGradient = 'radial-gradient(139.93% 139.93% at 50% 67.5%, #5CC4FF 0.01%, #2257DE 100%)';
const queueService = new QueueService();
interface IStateProps {
    configState: ConfigState
}
interface IDispatchProps {
    setOutletId: typeof setOutletId;
}
const mapStateToProps = (state: ApplicationState):IStateProps => ({
    configState: state.configState
})
const mapDispatchToProps  = {
    setOutletId,
    setConfig
}

interface ButtonDisplayProps {
    title: string;
    path: string;
    currentPath: string;
    onSelectPage: (path: string) => void;
}
const ButtonDisplay = (props: ButtonDisplayProps) => {
    const { title, path, currentPath, onSelectPage } = props;
    const onClickButton = useCallback(():void => {
        onSelectPage(path)
    }, [currentPath]);

    return (
        <Button variant='outlined' sx={{
            borderRadius: '2rem',
            textTransform: 'capitalize',
            background: currentPath === path ? '#93c5fd' : 'transparent',
            ':hover': {
                background: "#bfdbfe"
            }
        }}
            onClick={onClickButton}
        >
            {title}
        </Button>
    )
}

type Props = IStateProps & IDispatchProps;
const HomePage = (props: Props) => {
    const navigate = useNavigate();
    const [outletId, setOutletId] = useState<string>('');
    const [currentPath, setCurrentPath] = useState<string>('');
    const isDisabled = () => outletId && outletId !== '' && currentPath && currentPath !== '';

    useEffect(():void => {
        const {outletId} = props.configState;
        outletId && outletId !== '' && setOutletId(outletId);
        queueService.checkBearerToken();
    },[]);

    const saveConfig = useCallback(():void => {
        props.setOutletId(outletId);
        navigate(currentPath);
    },[currentPath, outletId]);

    const onChangeOutletId = useCallback(
        (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void =>  
            setOutletId(event.target.value), [setOutletId]
    )

    const onSelectActivePath = useCallback((path: string): void => {
        setCurrentPath(path)
    }, [setCurrentPath])

    return (
        <div className={`h-screen w-screen`} style={{ background: bgGradient }}>
            <div className='justify-center items-center flex flex-col gap-16 h-full' >
                <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                        <Stack spacing={4} sx={{ marginTop: '3rem' }}>
                            <TextField
                                value={outletId}
                                onChange={onChangeOutletId}
                                required
                                label="Outlet Id"
                            />
                        </Stack>
                        <Stack spacing={2} sx={{ marginTop: '1rem' }}>
                            <ButtonDisplay 
                                path="/display/pick" 
                                title="Ambil Antrian (Kios)" 
                                currentPath={currentPath}
                                onSelectPage={onSelectActivePath}
                                />
                            <ButtonDisplay 
                                path="/display/register" 
                                title="Antrian Pendaftaran" 
                                currentPath={currentPath}
                                onSelectPage={onSelectActivePath}
                                />
                            <ButtonDisplay 
                                path="/display/register-fcm" 
                                title="Antrian Pendaftaran V2" 
                                currentPath={currentPath}
                                onSelectPage={onSelectActivePath}
                                />
                            <ButtonDisplay 
                                path="/display/phlebotomy" 
                                title="Phlebotomy" 
                                currentPath={currentPath}
                                onSelectPage={onSelectActivePath}
                                />
                            <ButtonDisplay 
                                path="/display/poli" 
                                title="Poli" 
                                currentPath={currentPath}
                                onSelectPage={onSelectActivePath}
                                />
                        </Stack>
                    </CardContent>
                    <CardActions sx={{display: "flex", justifyContent: "center"}}>
                        <Button onClick={saveConfig} 
                            sx={{background: "#fb923c", ':hover': {background: '#fbbf24'}}} 
                            fullWidth variant="contained"
                            disabled={!isDisabled()}
                            >
                            Simpan
                        </Button>
                    </CardActions>
                </Card>
            </div>
        </div>
    )
}
export default reduxConnect(mapStateToProps, mapDispatchToProps)(HomePage)